module.exports = __webpack_public_path__ + "static/media/help.062f813c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help.svg
// module id = 389
// module chunks = 0